import ArrowRightIcon from "@ant-design/icons/ArrowRightOutlined";
import CheckIcon from "@ant-design/icons/CheckCircleFilled";
import LoginIcon from "@ant-design/icons/LoginOutlined";
import { Card } from "antd";
import Button from "antd-button-color";
import React, { useEffect, useState, useRef } from "react";
import BasicErrorView from "../../../components/ErrorView/BasicErrorView/BasicErrorView";
import Loading from "../../../components/Loading/Loading";
import Logo from "../../../components/Logo/Logo";
import BasicHeaderLayout from "../../../layouts/BasicHeaderLayout/BasicHeaderLayout";
import { AppManager } from "../../../manager";
import { CheckoutContent, CheckoutInterface } from "./CheckoutContent";
import Styles from "./Signup.scss";

const SignupContent: React.FC<{ info: CheckoutInterface }> = ({ info }) => {
    return (
        <div className={Styles.ContentContainer}>
            <CheckoutContent {...info} />
        </div>
    );
};

const SubscriptionCard: React.FC<{ onSelect: () => void; product: any }> = ({ product, onSelect }) => {
    const price = product.default_price.unit_amount / 100;
    const features = ["feature 1", "feature 2", "feature 3"];
    return (
        <div className={Styles.SubscriptionCard}>
            <div className={Styles.Header}>
                {product.name}
                <div className={Styles.HeaderLine} />
            </div>
            <div className={Styles.PriceContainer}>
                <div className={Styles.Dollar}>$</div>
                <div className={Styles.Price}>{`${price.toFixed(2)}`.split(".")[0]}</div>
                <div className={Styles.Cents}>{`${price.toFixed(2)}`.split(".")[1]}</div>
                <div className={Styles.PerSeat}>/seat</div>
                <div className={Styles.PerMonth}>/{product.default_price.recurring.interval}</div>
            </div>
            <div className={Styles.Content}>
                <div className={Styles.Features}>
                    {features.map((item, ind) => (
                        <div key={ind} className={Styles.FeatureItem}>
                            <CheckIcon /> <div className={Styles.Name}>{item}</div>
                        </div>
                    ))}
                </div>
                <div className={Styles.Actions}>
                    <Button size="large" type="primary" onClick={onSelect}>
                        Create Account
                    </Button>
                </div>
            </div>
        </div>
    );
};

const SignupChoiceView = () => {
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState<string>();
    const [dealerGroup, setDealerGroup] = useState<any>(); // TODO: typings
    const [planner, setPlanner] = useState<any>();

    const loadSignupInfo = () => {
        setLoading(true);
        setLoadError(undefined);
        console.log("LOADING...");
        AppManager.auth.fetchAuthInfo((err, data) => {
            setLoading(false);
            if (err) setLoadError(`${err}`);
            else {
                setDealerGroup(data!.products.find((r) => r.id == data!.dealerGroupProdId));
                setPlanner(data!.products.find((r) => r.id == data!.plannerProdId));
            }
        });
    };

    useEffect(() => {
        loadSignupInfo();
    }, []);
    return (
        <div className={Styles.ChoiceContainer}>
            <div className={Styles.MainHeader}>
                <Logo imgStyle={{ width: 50, height: 50 }} />
                <h3 className={Styles.Title}>Sign up</h3>
                <Button style={{ width: 150 }} icon={<LoginIcon />} size="large" type="success" onClick={() => AppManager.route.gotoLogin()}>
                    Login
                </Button>
            </div>
            <div className={Styles.TopBg}>
                <div className={Styles.Text}>Choose your organization type to create an account</div>
            </div>
            <div className={Styles.MainContent}>
                {loading ? (
                    <Loading />
                ) : planner && dealerGroup ? (
                    <>
                        <SubscriptionCard key="dealer-group" product={dealerGroup} onSelect={AppManager.route.gotoDealerGroupSignup} />
                        <SubscriptionCard key="fin-planning" product={planner} onSelect={AppManager.route.gotoFinancialPlannerSignup} />
                    </>
                ) : (
                    <BasicErrorView error={"Something went wrong. Contact support if this persists"} description={`${loadError}`} />
                )}
            </div>
        </div>
    );
};

const SignupPage = () => {
    return <BasicHeaderLayout content={<SignupChoiceView />} noInnerPadding noHeader />;
};

export const SignupDealerGroup = () => {
    return (
        <BasicHeaderLayout content={<SignupContent info={{ accountType: "dealer_group" }} />} noInnerPadding title="Ausplan Dealer Group Account" />
    );
};

export const SignupDefaultPlanner = () => {
    return (
        <BasicHeaderLayout content={<SignupContent info={{ accountType: "planner" }} />} noInnerPadding title="Ausplan Financial Planner Account" />
    );
};

export default SignupPage;
